export { default as SvgIcon } from 'components/helpers/SvgIcon/SvgIcon';
export type { SvgIconProps, SvgIconSize, IconTypes } from 'components/helpers/SvgIcon/SvgIcon';
